import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { Spin, Tooltip, Switch, message, Select } from "antd";
import EditWashingEquip from "./EditWashingEquip";
import AddWashingEquip from "./AddWashingEquip";
import {
  getApiBaseUrl,
  GET_WASH_EQUIP,
  UPDATE_WASH_EQUIP_STATUS,
  GET_LOCATIONS,
} from "../../Config/Config";
import Swal from "sweetalert2";

const WashingEquip = () => {
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(0);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();

      if (data?.Status && Array.isArray(data.ResultData)) {
        setLocations(data.ResultData);
      } else {
        console.error("Invalid data format:", data);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (value) => {
    setSelectedLocation(value);
    console.log("Selected BlockId:", value);
  };

  const fetchEquipments = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}${GET_WASH_EQUIP}&blockid=${selectedLocation}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setData(result?.ResultData || []);
    } catch (error) {
      console.error("Failed to fetch equipment data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEquipments();
  }, [selectedLocation]);

  const handleToggleWashingEquipStatus = async (record, newStatus) => {
    const actionText = newStatus ? "activate" : "deactivate";

    const confirmResult = await Swal.fire({
      title: `Are you sure?`,
      text: `You are about to ${actionText} this equipment.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    setIsLoading(true);

    try {
      const sessionData = JSON.parse(sessionStorage.getItem("user"));
      const userId = parseInt(sessionData?.UserID);

      const payload = {
        Id: record.Id,
        UpdatedBy: userId,
        IsActive: Number(newStatus),
      };

      const response = await fetch(
        `${getApiBaseUrl()}${UPDATE_WASH_EQUIP_STATUS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result?.Status) {
        message.success(
          `Equipment status updated to ${newStatus ? "Active" : "Inactive"}`
        );
        // Optionally refresh your data:
        // fetchData();
      } else {
        throw new Error(result?.Message || "Failed to update");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      message.error("Failed to update status");
    } finally {
      setIsLoading(false);
      fetchEquipments();
    }
  };

  const columns = [
    {
      title: "Equipment Name",
      dataIndex: "EquipmentName",
      key: "EquipmentName",
      sorter: (a, b) => a.EquipmentName.localeCompare(b.EquipmentName),
    },
    {
      title: "Serial Number",
      dataIndex: "SerialNumber",
      key: "SerialNumber",
      sorter: (a, b) => a.SerialNumber.localeCompare(b.SerialNumber),
    },
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <span className={`badge ${isActive ? "bg-success" : "bg-danger"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a, b) => a.IsActive - b.IsActive,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            <Link
              to="#"
              className=" me-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#EditWashingEquipOffcanvas"
              onClick={() => setSelectedEquip(record)}
              title="Edit"
            >
              <i data-feather="edit" className="feather-edit text-info"></i>
            </Link>

            <Tooltip title={record.IsActive ? "Active" : "Inactive"}>
              <Switch
                size="small"
                checked={record.IsActive}
                onChange={() =>
                  handleToggleWashingEquipStatus(record, !record.IsActive)
                }
                style={{
                  backgroundColor: record.IsActive ? "#52c41a" : "#ff4d4f",
                }}
              />
            </Tooltip>

            {/* <Link
              to="#"
              className="me-2 p-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightWashingEquip"
              aria-controls="offcanvasRightWashingEquip"
              onClick={() => setSelectedEquip(record)}
              title="Update Status"
            >
              <i
                data-feather="trash-2"
                className="feather-trash-2 text-danger"
              ></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  const [selectedEquip, setSelectedEquip] = useState();

  return (
    <>
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Washing Equipment
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Washing Equipment</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                // onClick={() => handleAdd(masterType)}
                data-bs-toggle="offcanvas"
                data-bs-target="#AddWashingEquipOffcanvas"
                aria-controls="AddWashingEquipOffcanvas"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>

          <div>
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
                <div className="search-set mt-4"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <Select
                    showSearch
                    placeholder="Select Block"
                    optionFilterProp="children"
                    value={selectedLocation === 0 ? 0 : selectedLocation}
                    onChange={handleChange}
                    style={{ width: 200 }}
                    dropdownStyle={{ width: 200 }}
                    filterOption={(input, option) =>
                      (option?.children ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option key={0} value={0} >
                      All
                    </Option>
                    {locations.map((loc) => (
                      <Option key={loc.BlockId} value={loc.BlockId}>
                        {loc.BlockName}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : data.length > 0 ? (
                    <Table dataSource={data} columns={columns} />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          <EditWashingEquip editObj={selectedEquip} />
          <AddWashingEquip />
        </>
      </div>
    </>
  );
};

export default WashingEquip;
